import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { printDate, printPrice, printTime } from '@guryou/utils';
import { useTheme } from '@material-ui/core/styles';
import Modal from './shared/Modal';
import Sessions from '../modules/profile/Sessions';

const ServiceCard = ({ item, isNotVideo = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isSessionsModalOpen, setIsSessionsModalOpen] = useState(false);

  const handleShowSessions = () => setIsSessionsModalOpen(true);
  const closeSessionsModal = () => setIsSessionsModalOpen(false);

  const headerColor = item.color ? `#${item.color}` : theme.palette.primary.main;

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow">
      {/* Header with color */}
      <div className="px-4 py-3 flex items-center justify-between" style={{ backgroundColor: headerColor }}>
        <span className="text-white text-sm font-medium truncate flex-1 mr-2">
          {item.groupName ? `${t('GROUP.group')} - ${item.groupName}` : t('GENERAL.noGroup')}
        </span>
        <span className="text-white text-sm font-semibold whitespace-nowrap">{printPrice(item.price)}</span>
      </div>

      {/* Content */}
      <div className="p-4 space-y-3">
        <h4 className="text-lg font-bold text-gray-900">{item.name || t('GENERAL.noName')}</h4>

        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-gray-600 font-medium">{t('PROFILE.date')}:</span>
            <span className="text-gray-900">{printDate(item.date)}</span>
          </div>

          {isNotVideo && (
            <>
              <div className="flex items-center justify-between">
                <span className="text-gray-600 font-medium">{t('PROFILE.time')}:</span>
                <span className="text-gray-900">{printTime(item.date)}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-600 font-medium">{t('PROFILE.duration')}:</span>
                <span className="text-gray-900">{`${item.duration} ${item.timeUnit}s`}</span>
              </div>
              {item.resourceName ? (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600 font-medium">{t('PROFILE.resource')}:</span>
                  <span className="text-gray-900">{item.resourceName}</span>
                </div>
              ) : (
                <button onClick={handleShowSessions} className="text-feel-primary hover:underline font-medium text-sm w-full text-left">
                  {t('SESSIONS.titlePlural')}
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <Modal isOpen={isSessionsModalOpen} onClose={closeSessionsModal} title={`${item.name} (${t('SESSIONS.titlePlural')})`}>
        <div className="p-6">
          <Sessions service={item} />
        </div>
      </Modal>
    </div>
  );
};

export default ServiceCard;
